import React, { useState } from 'react';
import AttachmentUpload from './AttachmentUpload';
import CommonOptionFields from './CommonOptionFields';

const RestaurantForm = ({ onSave, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    restaurantName: initialData?.restaurantName || '',
    restaurantAddress: initialData?.restaurantAddress || '',
    date: initialData?.date || '',
    time: initialData?.time || '',
    nameOnReservation: initialData?.nameOnReservation || '',
    partySize: initialData?.partySize || '',
    confirmationNumber: initialData?.confirmationNumber || '',
    phoneNumber: initialData?.phoneNumber || '',
    description: initialData?.description || '',
    price: initialData?.price || '',
    isOption: initialData?.isOption || false,
    optionDescription: initialData?.optionDescription || '',
    paymentTiming: initialData?.paymentTiming || 'with_deposit',
    optionalDepositAmount: initialData?.optionalDepositAmount || '',
    agentNotes: initialData?.agentNotes || '',
    agentCommission: initialData?.agentCommission ?? null,
    photos: initialData?.photos || [],
    documents: initialData?.documents || []
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      type: 'restaurant',
      price: parseFloat(formData.price) || 0,
      paymentTiming: formData.paymentTiming,
      optionalDepositAmount: formData.optionalDepositAmount ? parseFloat(formData.optionalDepositAmount) : null,
      partySize: parseInt(formData.partySize) || 1
    });
  };

  return (
    <form onSubmit={handleSubmit} className="component-form restaurant-form">
      <div className="form-section">
        <h4>Restaurant Information</h4>
        
        <div className="form-group">
          <label>Title/Description*</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({...formData, title: e.target.value})}
            placeholder="e.g., Dinner at Le Bernardin"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Restaurant Name*</label>
            <input
              type="text"
              value={formData.restaurantName}
              onChange={(e) => setFormData({...formData, restaurantName: e.target.value})}
              placeholder="e.g., Le Bernardin"
              required
            />
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              value={formData.phoneNumber}
              onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
              placeholder="e.g., (555) 123-4567"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Restaurant Address*</label>
          <input
            type="text"
            value={formData.restaurantAddress}
            onChange={(e) => setFormData({...formData, restaurantAddress: e.target.value})}
            placeholder="e.g., 155 West 51st Street, New York, NY 10019"
            required
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Reservation Details</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>Date*</label>
            <input
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({...formData, date: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Time*</label>
            <input
              type="time"
              value={formData.time}
              onChange={(e) => setFormData({...formData, time: e.target.value})}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Name on Reservation*</label>
            <input
              type="text"
              value={formData.nameOnReservation}
              onChange={(e) => setFormData({...formData, nameOnReservation: e.target.value})}
              placeholder="e.g., John Smith"
              required
            />
          </div>
          <div className="form-group">
            <label>Party Size*</label>
            <input
              type="number"
              value={formData.partySize}
              onChange={(e) => setFormData({...formData, partySize: e.target.value})}
              placeholder="Number of guests"
              min="1"
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Confirmation Number</label>
            <input
              type="text"
              value={formData.confirmationNumber}
              onChange={(e) => setFormData({...formData, confirmationNumber: e.target.value})}
              placeholder="e.g., RES123456"
            />
          </div>
          <div className="form-group">
            <label>Price per Person</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => setFormData({...formData, price: e.target.value})}
              placeholder="0.00"
              min="0"
              step="0.01"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Additional Notes</label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({...formData, description: e.target.value})}
            placeholder="Special requests, dietary restrictions, occasion, etc..."
            rows="3"
          />
        </div>
      </div>

      <CommonOptionFields formData={formData} setFormData={setFormData} />

      <AttachmentUpload
        photos={formData.photos}
        documents={formData.documents}
        onPhotosChange={(photos) => setFormData({...formData, photos})}
        onDocumentsChange={(documents) => setFormData({...formData, documents})}
        maxPhotos={5}
        maxDocuments={3}
        showPhotos={true}
        showDocuments={true}
      />

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          {initialData ? 'Update' : 'Add'} Restaurant
        </button>
      </div>
    </form>
  );
};

export default RestaurantForm;
